export default __webpack_public_path__ + "static/media/classify-alden.92ba8141.jpg";